import * as React from 'react'

import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility'

const exploreDemoLink = `${window.postbuildEnv.DEFAULT_URL}/teachers/view_demo`

function goToDemo() {
  window.location.href = exploreDemoLink
}

const DemoModal = ({ close, size }) => {
  const { modalRef, } = useModalAccessibility(close)

  return (
    <div className="modal-container welcome-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="exploreDemoModalTitle"
        aria-modal={true}
        className="quill-modal explore-demo-modal"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div className="modal-body">
          <h1 id="exploreDemoModalTitle">Explore Demo</h1>
          <div className="explore-demo-modal-text">
            <p>You are about to enter a Demo Account. All data is for demo purposes only - you can exit the Demo and re-enter your own account at any time.</p>
          </div>
          <button className="quill-button contained green medium focus-on-light" onClick={goToDemo} type="button">Let&apos;s go!</button>
          <button className="quill-button outlined grey medium cancel-button focus-on-light" onClick={close} type="button">Cancel</button>
        </div>
      </div>
    </div>
  )
}

export default DemoModal
